<template>
    <!-- 票券订单那禁用组件 -->
    <div>
        <a-modal
        centered
        :maskClosable="false"
        :destroyOnClose="true"
        :title="`票券${forbidden ? '禁用' : '解禁'}`"
        :visible="visible"
        @cancel="cancel"
        :width="800"
        >
            <a-spin :spinning="spinning"> 
                <member-card :ticketData="ticketData"></member-card>
                <div v-show="visible && Boolean(giveSelectorLength)">
                    <a-divider ></a-divider>
                    <div class="give-info-container">
                        <div class="mb8">
                            <span class="font-bigger text-color-85">赠品信息</span>
                            <span class="text-primary ml24">该{{forbidden ? '禁用' : '解禁'}}票券为活动主商品，如下赠品将会被{{forbidden ? '禁用' : '解禁'}}</span>
                        </div>
                        <member-order-give-selector :ticketGivenId="ticketData.userTicketNo" :owner="ticketData.phone" :disabled="forbidden" :isSelected="true" :isForbidden="forbidden" ref="giveSelector"></member-order-give-selector>
                    </div>
                </div>
            </a-spin>
            <a-divider></a-divider>
            <a-form :form="form">
                <remark :labelSpan="4" :wrapperSpan="18" :operateCode="forbidden?'TicketForbidden':'TicketRelieveForbidden'" />
                <shop :labelSpan="4" :wrapperSpan="18" :shops="ticketData.suitShopReserveStockConfigs"/>
            </a-form>
            <template slot="footer">
                <a-button @click="cancel">取消</a-button>
                <a-button type="primary" :loading="loading" @click="ok(false)">确定</a-button>
            </template>
        </a-modal>
        <!-- 操作积分、储值余额不足提示 -->
        <a-modal
        centered
        :maskClosable="false"
        :destroyOnClose="true"
        title="提示"
        :visible="visibleConfirm"
        @cancel="visibleConfirm = false"
        :width="420"
        >
            <div>
                该笔订单积分、储值余额不足，是否继续进行禁用？
            </div>
            <div>
                禁用后，该账户积分、储值余额将会清0。
            </div>
            <template slot="footer">
                <a-button @click="visibleConfirm = false">取消</a-button>
                <a-button type="primary" :loading="loading" @click="ok(true)">确定</a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
    import memberCard from '@/components/modules/order/member-card.component'
    import memberOrderGiveSelector from '@/components/modules/order/member-order-give-selector.component'
    import remark from '@/components/modules/platform/remark.component';
    import shop from '@/components/modules/platform/shop.component';

    export default {
        name: "member-order-forbidden",
        zh: "票券订单那禁用组件",
        components: {
            memberCard,
            memberOrderGiveSelector,
            remark,
            shop,
        },
        data() {
            return {
                forbidden: true,
                visible: false,
                spinning: false,
                loading: false,
                ticketData: {},
                dataSource: [],
                userTicketId: null,
                visibleConfirm: false,
                giveSelectorLength: 0,
            }
        },
        props: {
        },
        computed: {},
        watch: {
        },
        methods: {
            ok(ignoreNotEnough) {
                this.form.validateFields((errors, values) => {
                    if (Boolean(errors)) {
                        return false;
                    };
                    const shopItem = JSON.parse(values.shop)
                    let { ticketData } = this;
                    let giveActivityDetails = [];
                    let { giveSelector } = this.$refs;
                    if (Boolean(giveSelector) && giveSelector.getSelectedRows()) {
                        giveActivityDetails.push({
                            isMainGoods: true,
                            operateNum: 1,
                            operateObjectCategory: "TICKET",
                            userTicketNo: ticketData.userTicketNo,
                        })
                        giveSelector.getSelectedRows().forEach(el => {
                            switch (el.goodsType) {
                                case 1:
                                    giveActivityDetails.push({
                                        operateNum: el.goodsNum,
                                        operateObjectCategory: "TICKET",
                                        userTicketNo: el.userTicketNo,
                                    })
                                    break;
                                case 7:
                                    giveActivityDetails.push({
                                        operateNum: el.goodsNum,
                                        operateObjectCategory: "COUPON",
                                        userCouponNo: el.userCouponId,
                                    })
                                    break;
                                case 5:
                                    giveActivityDetails.push({
                                        operateNum: el.goodsNum,
                                        balanceCardId: el.goodsId,
                                        operateObjectCategory: "BALANCE",
                                    })
                                    break;
                                case 8:
                                    giveActivityDetails.push({
                                        operateObjectCategory: "POINT",
                                        pointNum: el.grantNum,
                                    })
                                    break;
                                default:
                                    break;
                            }
                        })
                    }
                    this.loading = true;
                    const isForbidden = ["unForbidden", "forbidden"]
                    this.$api.order[isForbidden[Number(this.forbidden)]]({
                        body: {
                            ...values,
                            goods: ticketData.isActivity ? ticketData.giveGrantId : ticketData.userTicketNo,
                            goodsType: ticketData.isActivity ? "ACTIVITY" : "TICKET",
                            userId: ticketData.userId,
                            phone: ticketData.phone,
                            shopId: shopItem.id,
                            shopName: shopItem.name,
                            giveActivityDetails,
                        }
                    }).then(res => {
                        this.loading = false;
                        this.visible = false;
                        this.visibleConfirm = false;
                        this.$message.success('操作成功');
                        if(this.$listeners.hasOwnProperty('ok')) {
                            setTimeout(() => {
                                this.$emit('ok');
                            }, 1000);
                        }
                    }).catch(error => {
                        this.loading = false;
                        if (error && error.code === 200001) {
                            this.visibleConfirm = true;
                            this.$message.error(error.msg);
                        }
                    });
                });
            },
            show(userTicketId, forbidden) {
                // forbidden: 
                // true 禁用 false 解禁
                this.userTicketId = userTicketId;
                this.forbidden = forbidden;
                this.visible = true;
                this.getDetail();
            },
            cancel() {
                this.visible = false;
                this.$emit('changeVisibleForbbiden', false);
                setTimeout(() => {
                    this.userTicketId = null;
                    this.forbidden = true;
                }, 300);
            },
            /**
             * @getDetail 获取基础票券详情
             */
            getDetail() {
                this.spinning = true;
                this.$api.order
                .detailUserTicket({
                    params: {userTicketNo: this.userTicketId}
                })
                .then(res => {
                    this.spinning = false;
                    res.validStartTime = res.validStartTime && res.validStartTime.split(" ")[0];
                    res.validEndTime = res.validEndTime && res.validEndTime.split(" ")[0];
                    res.isActivity = res.giveGrantId && !res.isGift && !res.isBonus;
                    this.ticketData = res;
                    this.$nextTick(() => {
                        this.$refs.giveSelector.getUserTicketGiveInfoVo().then(res => {
                            this.giveSelectorLength = res && res.length;
                        })
                    })
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        updated() {},
        mounted() {},
    };
</script>

<style lang="scss">
    .give-info-container {
        background-color: #f3f3f3;
        padding: 14px;
    }
</style>
